import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../services/axios";


function SubscriptionSuccess() {

    const navigate = useNavigate();

    const params = new URLSearchParams(window.location.search);
    const subscriptionId = params.get("subscriptionId");
    const orderId = params.get("orderId");
    const paymentId = params.get("paymentId");

    const [status, setStatus] = useState("checking");
    const [redirectTimer, setRedirectTimer] = useState(5);

    const isOrderPayment = Boolean(orderId);
    const checkoutId = orderId || subscriptionId;

    useEffect(() => {

        if (!checkoutId) return;
        const checkStatus = async () => {
            try {
                const endpoint = isOrderPayment
                    ? `${API_BASE_URL}/subscriptions/order-status/${orderId}`
                    : `${API_BASE_URL}/subscriptions/status/${subscriptionId}`;

                const res = await fetch(endpoint);
                const data = await res.json();
                
                const newStatus = (data?.resultObject || data?.status || "").toLowerCase();
                if (!newStatus) return;
                setStatus(newStatus);

            } catch (error) {
                console.error("Subscription status check failed", error);
            }

        };
        checkStatus();
        const interval = setInterval(checkStatus, 3000)
        return () => clearInterval(interval);

    }, [checkoutId, isOrderPayment, orderId, subscriptionId]);



    useEffect(() => {

        if (status !== "active" && status !== "success") return;
        
        const timer = setInterval(() => {
            setRedirectTimer((prev) => {
                if (prev === 1) {
                    navigate("/dashboard");
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
        return () => clearInterval(timer);
    }, [status, navigate]);


    return (

        <div className="subscription-status-root">
            <div className="subscription-status-card">
                {status !== "active" && status !== "success" && status !== "payment_failed" && (
                    <>
                        <div className="payment-icon-circle processing">
                            <div className="payment-icon-inner">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="12" r="10" opacity="0.3"/>
                                    <path d="M12 2a10 10 0 0 1 10 10" strokeLinecap="round">
                                        <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite"/>
                                    </path>
                                </svg>
                            </div>
                        </div>
                        <h2 className="payment-status-title">
                            Processing Payment
                        </h2>
                        <p className="payment-status-description">
                            We're confirming your payment with our payment provider. This usually takes just a few seconds.
                        </p>
                        <div className="status-progress">
                            <div className="progress-bar">
                                <div className="progress-fill"></div>
                            </div>
                        </div>
                    </>
                )}
                {(status === "active" || status === "success") && (
                    <>
                        <div className="payment-icon-circle success">
                            <div className="payment-icon-inner">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                            </div>
                        </div>
                        <h2 className="payment-status-title">
                            Payment Successful
                        </h2>
                        <p className="payment-status-description">
                            Your transaction was completed successfully. A confirmation email has been sent to your inbox.
                        </p>
                        <button className="payment-primary-btn" onClick={() => navigate("/dashboard")}>
                            Return to Dashboard
                        </button>
                        {redirectTimer > 0 && (
                            <p className="payment-redirect-info">
                                Redirecting in {redirectTimer} seconds...
                            </p>
                        )}
                    </>
                )}

                {status === "payment_failed" && (
                    <>
                        <div className="payment-icon-circle error">
                            <div className="payment-icon-inner">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                            </div>
                        </div>
                        <h2 className="payment-status-title">
                            Payment Failed
                        </h2>
                        <p className="payment-status-description">
                            Unfortunately, your payment could not be processed at this time. Please check your card details and try again.
                        </p>
                        <button className="payment-primary-btn" onClick={() => navigate("/club/manage-pricing")}>
                            Try Again
                        </button>
                        <button className="payment-secondary-btn" onClick={() => navigate("/support")}>
                            Contact Support
                        </button>
                    </>
                )}

            </div>

        </div>

    );
}

export default SubscriptionSuccess;